import { GetPostsStore, getPostsUseCase } from "../../shared/useCases/posts/getPostsUseCase";

const getPostsCarruselUseCase = (store: GetPostsStore) =>
getPostsUseCase(store, false)

export { getPostsCarruselUseCase }; 